import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { EcommerceSegmentationType } from '@/helpers/entities/enums/v2/EcommerceSegmentationType';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import { includes } from 'lodash';
/**
 * Mixin Class for Segmentation Type Validations and Helper Functions
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version 0.1.6
 */
let SegmentationTypeMixin = class SegmentationTypeMixin extends Mixins(RouterParamsAppMixin) {
    /**
     * Helper Method which return custom rules
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version 0.1.6
     *
     * @returns { EcommerceSegmentationType[] } list of custom ecommerce
     * segmentation types
     */
    get customRules() {
        return [
            EcommerceSegmentationType.Shipping,
            EcommerceSegmentationType.Location,
            this.ecommerceCategory,
        ];
    }
    /**
     * Helper Method which validate if supplied category is custom
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version 0.1.6
     *
     * @returns {boolean}
     */
    isCustom(category) {
        return includes(this.customRules, category);
    }
    /**
     * Helper Method which validate if supplied category is location
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version 0.1.6
     *
     * @returns {boolean}
     */
    isLocation(category) {
        return EcommerceSegmentationType.Location === category;
    }
    /**
     * Helper Method which validate if supplied category is category
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version 0.1.6
     *
     * @returns {boolean}
     */
    isCategory(category) {
        return EcommerceSegmentationType.Category === category;
    }
    /**
     * Helper Method which validate if supplied category is store
     * @author Johsua Timario <johsua@gorated.ph>
     * @since Version 1.6.0
     *
     * @returns {boolean}
     */
    isStore(category) {
        return EcommerceSegmentationType.Store === category;
    }
    /**
     * Method return dynamic custom rule
     * Store for multi-store
     * Category for b2c ecommerce
     * @author Johsua Timario <johsua@gorated.ph>
     * @since Version 1.6.0
     *
     * @returns {EcommerceSegmentationType}
     */
    get ecommerceCategory() {
        if (this.bundleKey === 'mall-stores-management-bundle') {
            return EcommerceSegmentationType.Store;
        }
        return EcommerceSegmentationType.Category;
    }
};
SegmentationTypeMixin = __decorate([
    Component
], SegmentationTypeMixin);
export default SegmentationTypeMixin;
